module.exports = __webpack_public_path__ + "static/media/erigon-circle.98cbaf0b.png";